<template>
    <div class="content">
        <h2>技术鉴定委托书</h2>
        <el-form :model="form" ref="form" :rules="rules" label-width="110px">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="文号:" required>
                        <el-form-item prop="pre" style="width:140px; float:left;">
                        <el-input style="width:100px;"
                        v-model="form.pre"
                        placeholder=""
                        clearable
                        size="small"
                        />&nbsp;鉴委
                        </el-form-item>
                        <el-form-item prop="year" style="width:140px; float:left;">
                         〔<el-date-picker style="width:100px;"
                        v-model="form.year"
                        type="year" size="small"
                        placeholder="选择年">
                        </el-date-picker>
                        〕</el-form-item>
                        <el-form-item prop="month" style="width:90px; float:left;">
                            <el-input style="width:80px;"
                                v-model="form.month"
                                placeholder=""
                                clearable
                                size="small"
                                />
                        </el-form-item>
                        <el-form-item prop="bianhao" style="width:125px; float:left;">
                        <el-input style="width:100px;"
                        v-model="form.bianhao"
                        placeholder=""
                        clearable
                        size="small"
                        />&nbsp;号
                        </el-form-item>
                        <el-button type="primary" size="small" @click="getBh">获取编号</el-button>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="采集单位:" prop="cjdw">
                        <el-input
                        v-model="form.cjdw"
                        placeholder=""
                        clearable
                        size="small"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="采集物品:" prop="cjwp">
                        <el-input
                        v-model="form.cjwp"
                        placeholder=""
                        clearable
                        size="small"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="检测项目:" prop="jcxm">
                        <el-input
                        v-model="form.jcxm"
                        placeholder=""
                        clearable
                        size="small"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="联系人:" prop="lxr">
                        <el-select v-model="form.lxr" placeholder="请选择" size="small">
                            <el-option
                            v-for="(dict,index) in userOptions"
                                :key="index"
                                :label="dict.xm"
                                :value="dict.xm"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="联系电话:" prop="lxdh">
                        <!-- <el-select v-model="form.lxdh" placeholder="请选择" size="small">
                            <el-option
                                v-for="(dict,index) in userOptions"
                                :key="index"
                                :label="dict.ksdh"
                                :value="dict.ksdh"
                                ></el-option>
                        </el-select> -->
                        <el-input style="width:220px;"
                        v-model="form.lxdh"
                        placeholder=""
                        clearable
                        size="small"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="样品件数:" prop="js1">
                        <el-input
                        v-model="form.js1"
                        placeholder=""
                        clearable
                        size="small"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="其他资料件数:" prop="js2">
                        <el-input
                        v-model="form.js2"
                        placeholder="/"
                        clearable
                        size="small"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item>
                        <el-button type="primary" @click="submit('form')">生成技术鉴定委托书</el-button>
                        <el-button type="warning" v-if="isWs" @click="show()">预览</el-button>
                        <el-button type="danger" v-if="isWs" @click="edit()">编辑</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <div v-show="loading" class="loading">
            <i class="el-icon-loading"></i>
            <p>文书生成中...</p>
        </div>

        <el-dialog title="技术鉴定委托书" :visible.sync="dialogWordVisible"  width="600px" append-to-body :close-on-click-modal="false">
            <div v-loading="loadingWord">
                <p style="color: #ff0000;font-weight:bold;margin-bottom:20px;">* Word编辑后，请点击 "<i class="el-icon-refresh"></i>重新生成" 按钮，生成新的文书！！！</p>
                <p style="margin-bottom:20px;">
                    <el-button size="small" type="danger" @click="editWord()" icon="el-icon-edit">Word编辑</el-button>&nbsp;&nbsp;
                    <el-button size="small" type="primary" @click="resetWord()" icon="el-icon-refresh">重新生成</el-button>&nbsp;&nbsp;
                    <el-button size="small" type="warning" @click="showWord()" icon="el-icon-view">预 览</el-button>
                </p>
                <div slot="footer" class="dialog-footer" style="text-align:right;">
                    <el-button @click="dialogWordVisible = false">取 消</el-button>   
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
export default {
    name: "Layout",
    props:['code','pcId','pre','dwmc'],
    data() {
        return {
            loading:false,
            xm:'',
            dm:'',
            cmid:'',
            shi:'',
            xianqu:'',
            gzbm:'',
            gzzw:'',
            form:{
                pre:'',
                year:'',
                month:'',
                bianhao:'',
                cjdw:'',
                cjwp:'',
                jcxm:'',
                lxr:'',
                lxdh:'',
                js1:'',
                js2:'',
            },
            rules:{
                pre:[
                    { required: true, message: '文号不能为空', trigger: 'blur' }
                ],
                year:[
                    { required: true, message: '年份不能为空', trigger: ['change','blur'] }
                ],
                month:[
                    { required: true, message: '月份不能为空', trigger: 'blur' }
                ],
                bianhao:[
                    { required: true, message: '编号不能为空', trigger: ['change','blur'] }
                ],
            },
            userOptions:[],
            isWs:false,

            dialogWordVisible:false,
            loadingWord:false,
            wsPdf:'',
            docurl:'',
            zfXX:[],
            baseUrl:''
        }
    },
    components: {
    },
    computed: {
    },
    created() {
        console.log(this.code)
    },
    async mounted() {
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.xm = user.xm
        this.dm = user.dm
        this.cmid = user.c_mid
        this.shi = user.shi
        this.xianqu = user.xianqu
        this.gzbm = user.gzbm
        this.gzzw = user.gzzw
        if(this.pre){
            this.$set(this.form,'pre',this.pre)
        }
        if(this.dwmc){
            this.$set(this.form,'cjdw',this.dwmc)
        }
        let date = this.getDate(new Date(),'yyyy-MM-dd')
        let date1 = date.split('-')
        this.$set(this.form,'year',date1[0])
        this.$set(this.form,'month',date1[1])
        this.$set(this.form,'lxr',this.xm)
        this.getDh()
        axios({
            method: 'post',
            url: `https://xxswj.hzxhykj.com:9086/xx/lawEnforcer`,
            headers: { // 添加请求头
                "Content-Type": "application/json" // 明确声明为 JSON 格式
            },
            data: {
                cmid:this.cmid
            }
        })
        .then(response => {
            this.userOptions = response.data.data
        })
        .catch(error => {
            this.$message.error('获取监督员数据失败！');
            console.error('There was an error!', error);
        });
        
        this.getList()
    },
    methods: {
        async getList(){
            this.isWs = false
            //判断文书是否存在
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getExistWenshu&id=${this.pcId}&fileName=${escape('技术鉴定委托书')}&xcblFlag=`)
            if(data.data){
                if(data.data == '1'){
                    //有
                    this.isWs = true
                    this.getZfxx()
                }else{
                    this.getBh()
                }
                
            }
        },
        async getDh(){
            let data5 = await this.$axios.get(`${this.Global._baseUrl2}?act=getJdyDh&dm=${this.dm}`)
            if(data5.data){
                this.$set(this.form,'lxdh',data5.data[0].ksdh)
            }
        },
        async getBh(){
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getJsjdsWenhao&id=${this.pcId}&nianFen=${this.form.nianfen}&riqi=${this.form.month}`)
            console.log(data)
            if(data.data){
                    this.$set(this.form,'bianhao',data.data.data)
            }
        },
        async getZfxx(){
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getZfxxInfo&id=${this.pcId}`)
            console.log(data)
            this.wsUrl = ''
            this.docurl = ''
            this.wsPdf = ''
            this.zfXX = []
            if(data.data){
                this.zfXX = data.data
                this.wsUrl = 'mid='+data.data[0].dwmc_id+'&lsh='+data.data[0].lsh+'&wsnameEw=jishujiandingweituoshu&sjs='+new Date().getTime()
                let nm = 'jishujiandingweituoshu'
                this.docurl = 'https://dapc.scqwszfd.cn:9080/zfjl/'+data.data[0].dwmc_id+'/'+data.data[0].lsh+'/'+nm+'.docx'
                this.wsPdf = 'https://dapc1.scqwszfd.cn:8123/zfjl/'+data.data[0].dwmc_id+'/'+data.data[0].lsh+'/tupian/'+nm+'.pdf?timestrap='+new Date().getTime()
                
            }
        },
        submit(form){
            this.$refs[form].validate((valid) => {
                if (valid) {
                    let that = this
                    let nr = this.form.cjdw+'|'+this.form.cjwp+'|'+this.form.jcxm+'|'+this.form.lxr+'|'+this.form.lxdh+'|'+this.form.js1+'|'+this.form.js2 + '|' + this.form.pre+'|'+this.form.year+'|'+this.form.month+'|'+this.form.bianhao
                    this.loading = true
                    axios({
                        method: 'post',
                        url: `${this.Global._baseUrl2}`,
                        data: {
                            act: "makeWenshu",
                            id: `${this.pcId}`,
                            wsName:escape('技术鉴定委托书'),
                            shuju: nr,
                            caozuoStatus:1,
                            isOldWenshu:'',
                            wupin:'',
                            gzbm:`${escape(this.gzbm)}`,
                            gzzw:`${escape(this.gzzw)}`,
                            xm:`${escape(this.xm)}`,
                            dm:`${this.dm}`,
                            shi:`${escape(this.shi)}`,
                            xianqu:`${escape(this.xianqu)}`,
                        },
                        transformRequest: [function (data) {
                            data = qs.stringify(data);
                            return data;
                        }],
                        headers: { 'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}
                    }).then(res => {
                        this.loading = false
                        console.log(res)
                        if(res.data.code != -1){
                            console.log(res.data.code)
                            //code: "1"
                            //data: "showpdf.html?mid=dw400&lsh=202400096&wsnameEw=weishengjianduyijianshu&sjs=20240625144456060"
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            this.wsUrl = res.data.data.split('?')[1]
                            this.show()
                        }else{
                            if(res.data.data){
                                this.$message.error(res.data.data)
                            }else{
                                this.$message({
                                    message: '保存失败，请重新填写',
                                    type: 'error'
                                }); 
                            }
                        }
                    }).catch(res => {
                        this.loading = false
                    })
                }
            })
        },
        show(){
            if(this.wsUrl){
                let mid = this.wsUrl.split('&')[0].replace('mid=','')
                let lsh = this.wsUrl.split('&')[1].replace('lsh=','')
                let wsname = this.wsUrl.split('&')[2].replace('wsnameEw=','')
                let sjs = this.wsUrl.split('&')[3].replace('sjs=','')
                let url = this.$router.resolve({
                    path:'/pdf',
                    query:{
                        mid:mid,
                        lsh:lsh,
                        wsname:wsname,
                        sjs:sjs
                    }
                })
                window.open(url.href,'_blank')
            }else{
                this.$message.error('暂未制作本文书，不能预览！')
            }
        },
        edit(){
            this.dialogWordVisible = true
        },
        editWord(){
            if(this.docurl){
                let url = this.docurl
                console.log(url)
                POBrowser.openWindowModeless('https://office.bjklk.cn/bjclick-health/pageoffice/word2?docurl='+encodeURIComponent(url)+'&type=1&user_name=王若飞','width=1600px;height=1024px;');
            }else{
                this.$message.error('当前word文档地址不存在，请联系管理员！')
            }
        },
        showWord(){
            if(this.wsPdf){
                window.open(this.wsPdf,'_blank')
            }else{
                this.$message.error('暂未制作本文书，不能预览！')
            }
        },
        async resetWord(){
            this.loadingWord = true
            //重新生成文书
            // let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getwordpdfjpg&mid=${this.dqWord.mid}&lsh=${this.dqWord.lsh}&filecode=${this.dqWord.wsname}&DaLsh=`)
            let wsname = 'jishujiandingweituoshu.docx'
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getwordpdfjpg&mid=${this.zfXX[0].dwmc_id}&lsh=${this.zfXX[0].lsh}&filecode=${wsname}&DaLsh=`)
            console.log(data)
            if(data.data){
                if(data.data.pdfUrl){
                    window.open(data.data.pdfUrl,'_blank')
                    this.wsPdf = data.data.pdfUrl
                }else{
                    this.$message.error('暂未获取到文书，请重试或者联系管理员！')
                }
                this.loadingWord = false
            }else{
                this.loadingWord = false
            }
        },
    }
}
</script>


<style scoped>
.loading{ width: 100vw; height: 100vh; background: rgba(0,0,0,0.5); position: fixed; top:0;left: 0;text-align: center;}
.loading i{    font-size: 80px;color: #fff;opacity: 1; margin-top: 38vh;}
.loading p{   font-size: 20px; color: #fff; opacity: 1; line-height: 50px;}
.content{padding-right: 40px;}
.content h2{ text-align: center; padding: 10px 0; letter-spacing: 2px;}
</style>